import React from 'react';
import { Button } from 'react-bootstrap';
import { jobStateOptions } from '../../../app/pages/jobs/Artisan/ArtisanJobsForm';

const CJobItem = ({ data, active, applicant=false }) => {
  const date1 = new Date();
  const date2 = new Date(data?.createdAt);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  console.log(active);
  if (!data) return <div></div>;
  return (
    <>
      {/* Item BEGIN */}
      <div className={`job--item ${active && 'active'}`}>
        {/* Image */}
        <div
          className='master--imageContainer lazyload'
          //   data-bg='assets/images/02.png'
          style={{
            backgroundImage: `url(${
              data?.artisan?.logo
                ? data?.artisan?.logo
                : require('../../../assets/images/placeholders/placeholder-250x250.png')
            })`
          }}
        />
        {/* Data */}
        <div className='data'>
          <div className='date exep-1'>منذ {diffDays} ايام </div>
          <div className='title exep-1'>{data?.jobTitle}</div>
          <div className='subtitle exep-1'>
            {data?.applicants?.length} متقدم للوظيفة |{' '}
            {
              jobStateOptions.filter(stat => stat.value === data?.jobState)[0]
                ?.label
            }
            {/* {jobStateOptions.filter(stat => stat.value === data?.jobState)} */}
          </div>
         
          <div className='salary exep-1'>{data?.salary}</div>
        </div>
        {applicant && <div className='indicator'>
            <div className='item passed'>
              <div className='label'>
                <span className={`${data?.jobApplicationStatus === '1' && 'active'}`}>
                  متقدم
                </span>
              </div>
              <div className='marker'>
                <div className='dot' />
              </div>
            </div>
            {data?.jobApplicationStatus !== '1' ? (
              <div className='item passed'>
                <div className='label'>
                  <span className={`${data?.jobApplicationStatus === '0' && 'active'}`}>
                    تم رؤية السيرة الذاتية
                  </span>
                </div>
                <div className='marker'>
                  <div className='line' />
                  <div className='dot' />
                </div>
              </div>
            ) : (
              <></>
            )}

            {data?.jobApplicationStatus > 1 && (
              <div className='item active'>
                <div className='label'>
                  {data?.jobApplicationStatus === '2' && (
                    <span className='success'>غير مؤهل</span>
                  )}
                  {data?.jobApplicationStatus === '3' && (
                    <span className='success'>القائمة المختصرة</span>
                  )}
                  {data?.jobApplicationStatus === '4' && (
                    <span className='success'>تم المقابلة</span>
                  )}
                  {data?.jobApplicationStatus === '5' && (
                    <span className='success'>تم التعيين</span>
                  )}
                  {data?.jobApplicationStatus === '6' && (
                    <span className='success'>منسحب</span>
                  )}
                </div>
                <div className='marker'>
                  <div className='line' />
                  <div className='dot' />
                </div>
              </div>
            )}
          </div>}
        <div
          className={`job--type `}
          style={{ backgroundColor: data?.jobType === '1' && '#ECC063' }}
        >
          <div className='title'>
            {data?.jobType === '0' ? 'الياقات الزرقاء ' : 'حرفي'}
          </div>
          <div className='subtitle'>{data?.jobDescription.slice(0, 20)}</div>
          <div className='icon'>
            <svg viewBox='0 0 319 319' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M159.5 180.403C142.856 180.386 126.899 173.767 115.129 161.998C103.36 150.23 96.7399 134.273 96.7216 117.629V96.4541H222.265V117.633C222.246 134.274 215.627 150.228 203.861 161.995C192.094 173.762 176.141 180.382 159.5 180.403V180.403ZM105.343 105.076V117.633C105.471 131.911 111.232 145.561 121.373 155.612C131.514 165.663 145.215 171.302 159.493 171.302C173.772 171.302 187.472 165.663 197.614 155.612C207.755 145.561 213.516 131.911 213.644 117.633V105.076H105.343Z'
                fill='white'
              />
              <path
                d='M206.751 196.81C200.329 195.223 194.683 191.401 190.822 186.03C186.961 180.659 185.138 174.089 185.68 167.497L194.301 167.751C193.806 172.384 195.012 177.04 197.694 180.85C200.376 184.661 204.352 187.367 208.88 188.464L206.751 196.81Z'
                fill='white'
              />
              <path
                d='M112.172 196.815L110.107 188.447C114.644 187.377 118.631 184.679 121.312 180.866C123.994 177.052 125.183 172.387 124.656 167.756L133.277 167.488C133.861 174.095 132.05 180.692 128.176 186.075C124.302 191.458 118.622 195.27 112.172 196.815V196.815Z'
                fill='white'
              />
              <path
                d='M285.548 310.378H33.551L33.5898 306.029C33.4352 287.655 35.3395 269.322 39.2672 251.372C42.5265 235.687 49.417 220.985 59.3857 208.445L60.1056 207.583L89.8502 196.15L92.9454 204.199L65.3303 214.816C56.6121 226.173 50.5705 239.351 47.656 253.368C44.1495 269.261 42.3461 285.482 42.2761 301.757H276.625C274.948 263.369 267.365 234.857 253.484 214.756L226.076 204.199L229.176 196.155L259.019 207.652L259.769 208.708C275.676 231.059 284.082 262.852 285.41 305.934L285.548 310.378Z'
                fill='white'
              />
              <path
                d='M244.695 310.379H74.2882V241.677C74.2916 238.157 75.6916 234.782 78.1808 232.293C80.6701 229.803 84.0452 228.403 87.5655 228.4H231.417C234.938 228.403 238.313 229.803 240.802 232.293C243.291 234.782 244.691 238.157 244.695 241.677V310.379ZM82.9098 301.757H236.073V241.677C236.072 240.443 235.581 239.259 234.708 238.386C233.835 237.514 232.652 237.023 231.417 237.022H87.5655C86.3311 237.023 85.1476 237.514 84.2747 238.386C83.4019 239.259 82.911 240.443 82.9098 241.677V301.757Z'
                fill='white'
              />
              <path
                d='M231.922 237.026H203.25V193.642C203.251 192.613 203.495 191.599 203.964 190.684C204.432 189.768 205.112 188.976 205.946 188.375C206.78 187.773 207.745 187.377 208.762 187.222C209.779 187.066 210.818 187.153 211.794 187.478L227.469 192.694C228.765 193.121 229.894 193.947 230.692 195.054C231.49 196.161 231.918 197.493 231.913 198.858L231.922 237.026ZM211.885 228.404H223.3V200.384L211.872 196.573L211.885 228.404Z'
                fill='white'
              />
              <path
                d='M115.732 237.026H87.0783V198.854C87.0739 197.488 87.502 196.156 88.3011 195.049C89.1003 193.941 90.2296 193.115 91.5271 192.689L107.197 187.478C108.173 187.153 109.212 187.066 110.229 187.222C111.246 187.377 112.211 187.773 113.046 188.375C113.88 188.976 114.559 189.768 115.028 190.684C115.496 191.599 115.741 192.613 115.741 193.642L115.732 237.026ZM95.6913 228.404H107.111V196.573L95.6913 200.371V228.404Z'
                fill='white'
              />
              <path
                d='M159.547 211.661C145.684 211.661 131.687 204.556 117.944 190.538L124.1 184.502C136.273 196.918 148.482 203.164 159.858 203.039C171.234 202.914 182.731 196.711 194.194 184.558L200.453 190.464C187.322 204.388 173.687 211.518 159.931 211.652L159.547 211.661Z'
                fill='white'
              />
              <path
                d='M223.697 105.076H95.3034C93.6852 105.074 92.1339 104.43 90.9897 103.286C89.8454 102.141 89.2016 100.59 89.1993 98.9719V82.8365C89.2004 81.218 89.8439 79.666 90.9884 78.5215C92.1329 77.377 93.6848 76.7336 95.3034 76.7324H223.697C225.315 76.7336 226.867 77.377 228.012 78.5215C229.156 79.666 229.8 81.218 229.801 82.8365V98.9676C229.8 100.587 229.156 102.139 228.012 103.284C226.867 104.429 225.316 105.074 223.697 105.076V105.076ZM97.8209 96.4544H221.179V85.354H97.8209V96.4544Z'
                fill='white'
              />
              <path
                d='M224.744 85.3542H93.1523V77.9569C92.991 65.9757 96.3382 54.209 102.782 44.1066C109.225 34.0042 118.483 26.0074 129.415 21.1016L132.842 29.0119C123.644 33.1626 115.83 39.8657 110.328 48.3253C104.826 56.785 101.868 66.6458 101.804 76.7369H216.127C216.063 66.6458 213.104 56.785 207.603 48.3253C202.101 39.8657 194.287 33.1626 185.089 29.0119L188.516 21.1016C199.448 26.0074 208.706 34.0042 215.149 44.1066C221.593 54.209 224.94 65.9757 224.779 77.9569L224.744 85.3542Z'
                fill='white'
              />
              <path
                d='M182.252 85.3535H135.644L126.483 22.8467C126.264 21.3124 126.542 19.7482 127.276 18.383C128.009 17.0178 129.161 15.9233 130.562 15.2597C139.393 10.901 149.11 8.63379 158.959 8.63379C168.808 8.63379 178.525 10.901 187.356 15.2597C188.749 15.9303 189.892 17.0274 190.619 18.3917C191.346 19.756 191.62 21.3165 191.4 22.8467L182.252 85.3535ZM143.093 76.7318H174.803L182.731 22.6182C175.309 19.0562 167.182 17.2069 158.95 17.2069C150.718 17.2069 142.591 19.0562 135.17 22.6182L143.093 76.7318Z'
                fill='white'
              />
              <path
                d='M214.859 261.743H210.303C209.16 261.743 208.063 261.289 207.255 260.481C206.446 259.672 205.992 258.576 205.992 257.432C205.992 256.289 206.446 255.193 207.255 254.384C208.063 253.576 209.16 253.122 210.303 253.122H214.859C216.003 253.122 217.099 253.576 217.908 254.384C218.716 255.193 219.17 256.289 219.17 257.432C219.17 258.576 218.716 259.672 217.908 260.481C217.099 261.289 216.003 261.743 214.859 261.743Z'
                fill='white'
              />
              <path
                d='M108.697 261.743H104.141C102.997 261.743 101.901 261.289 101.092 260.481C100.284 259.672 99.8298 258.576 99.8298 257.432C99.8298 256.289 100.284 255.193 101.092 254.384C101.901 253.576 102.997 253.122 104.141 253.122H108.697C109.84 253.122 110.937 253.576 111.745 254.384C112.554 255.193 113.008 256.289 113.008 257.432C113.008 258.576 112.554 259.672 111.745 260.481C110.937 261.289 109.84 261.743 108.697 261.743Z'
                fill='white'
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default CJobItem;
